import { useState, useEffect } from 'react';

const LOGO_URL = 'https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/6f22b850c0f5b355d7e8e026585a5014.png';

const navLinks = [
  { label: 'Home', href: '#hero' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Why Choose Us', href: '#why' },
  { label: 'Contact', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 flex items-center justify-between h-18 py-3">
        {/* Logo + Name */}
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <div className="w-12 h-12 flex items-center justify-center">
            <img
              src={LOGO_URL}
              alt="Precision North Home Inspections Logo"
              className="w-12 h-12 object-contain"
            />
          </div>
          <div className="hidden sm:block">
            <p className={`font-heading font-bold text-base leading-tight transition-colors duration-300 ${scrolled ? 'text-navy' : 'text-white'}`}>
              Precision North
            </p>
            <p className={`text-xs font-body font-medium tracking-wide transition-colors duration-300 ${scrolled ? 'text-accent' : 'text-white/80'}`}>
              HOME INSPECTIONS
            </p>
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-accent ${
                scrolled ? 'text-navy/80' : 'text-white/90'
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
            className="ml-2 px-5 py-2 rounded-md bg-accent text-white text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-accent-light transition-colors duration-200"
          >
            Schedule an Inspection
          </a>
        </nav>

        {/* Mobile menu button */}
        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${scrolled ? 'text-navy' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile Nav Drawer */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3 shadow-md">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className="text-navy font-medium text-sm py-2 border-b border-gray-50 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNav('#contact'); }}
            className="mt-2 px-5 py-3 rounded-md bg-accent text-white text-sm font-semibold text-center cursor-pointer"
          >
            Schedule an Inspection
          </a>
        </div>
      )}
    </header>
  );
}
